import * as actionTypes from './../../actionTypes/campaign';

const initialState = {
    dataCampaign: null,
    timeToResetData: 0,
    cartBogoConfig: null,
    cartCampaign: {},
    query: ''
};

export default function common(prevState = initialState, action) {
    let xApiClient = 'desktop';
    // conditional imports on compilation
    '#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
    xApiClient = 'mobilesite';
    '#endif'; // eslint-disable-line
    switch (action.type) {
        case actionTypes.GET_CAMPAIGN_DATA:
            return Object.assign({}, prevState, {
                dataCampaign: xApiClient === 'mobilesite' ? prevState.dataCampaign : null,
                timeToResetData: 0,
                cartCampaign: {}
            });
        case actionTypes.GET_CAMPAIGN_SUCCESS:
            return Object.assign({}, prevState, {
                dataCampaign: xApiClient === 'mobilesite' ? action.data : action.data.activeAndValidData,
                cartCampaign: action.data.cart ? action.data.cart : {},
                timeToResetData: action.data.timeToResetData ? action.data.timeToResetData : 0,
                cartBogoConfig: action.data.cartBogoConfig ? action.data.cartBogoConfig : prevState.cartBogoConfig
            });
        case actionTypes.GET_CAMPAIGN_FAIL:
            return Object.assign({}, prevState, {
                dataCampaign: xApiClient === 'mobilesite' ? prevState.dataCampaign : null,
                cartCampaign: {},
                timeToResetData: 0
            });
        case actionTypes.CLEAR_CAMPAIGN_DATA:
            return Object.assign({}, prevState, {
                dataCampaign: null
            });
        case actionTypes.SET_QUERY_PARAMS:
            return Object.assign({}, prevState, {
                query: action.query
            });
        default:
            return prevState;
    }
}
